import styled from 'styled-components';
import {getFontWeight, getPrimitive} from '@tickchak/react-share/app';
import {BGImageCenter, DEFAULT_COLOR} from '../../globalVariables/GlobalVariables';
import {add, addWhite} from '../../assets/symbols/symbols/Symbols.css';
import zIndex from '../../globalVariables/zIndex';
import {dFlexBetween} from '../../globalVariables/GlobalFlex';

export const variableDropdown = styled.div`
    visibility: visible;
    appearance: none;
    border: 1px solid ${getPrimitive('grays.gray400')};
    border-radius: 21px;
    padding: 4px 30px 4px 16px;
    position: absolute;
    top: 10px;
    ${p => (p.theme?.rtl && p.theme.direction === 'ltr') || (!p.theme?.rtl && p.theme.direction === 'rtl') ? 'inset-inline-start' : 'inset-inline-end'}: 10px;
    ${BGImageCenter(add, '8px')}
    background-position: right 10px center;
    font-weight: ${getFontWeight('bold')};
    cursor: pointer;
    z-index: ${zIndex.baseRaised};
`;

export const item = styled.div`
    ${dFlexBetween};
    
    &::after {
        content: '';
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: ${DEFAULT_COLOR};
        ${BGImageCenter(addWhite, '10px')}
    }
`;
